<template>
  <c-modal :title="title" @close="$emit('close')" size="md">
    <div class="modal-body">
      <ul style="padding-left: var(--attendee-gap-md)">
        <li style="list-style: disc;" v-for="session in sessions">{{session}}</li>
      </ul>
    </div>
    <div class="modal-footer">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <c-button  theme="default" uppercase fill icon="fa-close" @click="$emit('close')">Close</c-button>
        <c-button  theme="primary" uppercase fill icon="fa-send" @click="$emit('agree')">Agree</c-button>
      </div>
    </div>
  </c-modal>
</template>



<script>
export default {
  props: ['sessions', 'title']
}
</script>